import { Bombs } from './Bombs.js';
import { FONT, light_smaller } from './Design.js';
import { Level } from './Level.js';
import { Player } from './Player.js';
import { Stars } from './Stars.js';
import { GAME_VERSION, isDebugging, multiplayerVs_SaveScore } from './State.js';

export class TwoPlayerScene extends Phaser.Scene {

    constructor ()
    {
        super({ key: 'TwoPlayerScene', active: false });

        this.score = 0;
        this.gameOver = false;
    }

    init(data) {
        this.playerOneTone=data.skinTone
        this.playerTwoSkinTone=data.skinTone2
    }
    
    create ()
    {
		this.add.image(400, 300, 'sky');

        //  Here we create the ground.
		let erdboden = this.physics.add.staticGroup();
		//  Scale it to fit the width of the game (the original sprite is 400x32 in size)
		erdboden.create(400, 568, 'ground').setScale(2).refreshBody();
		this.erdboden = erdboden;

        this.level = new Level(this.physics);

        this.playerOne = new Player('one', this.playerOneTone, this.physics, this.anims)
        this.playerTwo = new Player('two',this.playerTwoSkinTone, this.physics, this.anims, 400)
        this.levelText = this.add.text(380, 30, 'Level: ' + this.level.nr(), FONT);
        this.scoreText = this.add.text(400, 10,'', FONT);
		let stars = new Stars(this.physics, isDebugging()?2:12)
        this.stars = stars
        this.bombs = new Bombs(this.physics)
        this.add.text(750,580, 'v.'+GAME_VERSION, light_smaller)

        // Collisions
		this.physics.add.collider(this.playerOne.img(), erdboden);
		this.physics.add.collider(this.playerTwo.img(), erdboden);
		this.physics.add.collider(this.playerOne.img(), this.playerTwo.img());
        this.physics.add.collider(stars.img(), erdboden);
        
        this.level.addCollider(stars.img())
        this.level.addCollider(this.playerTwo.img())
        this.level.addCollider(this.playerOne.img())
        this.level.addCollider(this.bombs.grp())
        this.physics.add.collider(this.bombs.grp(), erdboden);

        const hitBomb = (p, b) => {
            this.playerOne.hitBombIfNameMatches(p)
            this.playerTwo.hitBombIfNameMatches(p)
        }
		this.physics.add.collider(this.playerOne.img(), this.bombs.grp(), hitBomb);
		this.physics.add.collider(this.playerTwo.img(), this.bombs.grp(), hitBomb);

        const collectStar = (player, star) => {
            star.disableBody(true, true)
            this.playerOne.scoreIfNameMatches(player)
            this.playerTwo.scoreIfNameMatches(player)
        }
        this.physics.add.overlap(stars.img(), this.playerOne.img(), collectStar, null, this);
        this.physics.add.overlap(stars.img(), this.playerTwo.img(), collectStar, null, this);

        // Controls
        this.cursorsWASD = {left: {isDown: false}, right: {isDown: false}, up: {isDown: false}}
		this.cursorsArrowKeys = this.input.keyboard.createCursorKeys();

		this.input.keyboard.on('keydown-W', () => this.p2up('up', true));
		this.input.keyboard.on('keyup-W', () => this.p2up('up', false));
		this.input.keyboard.on('keydown-A', () => this.p2up('left', true));
		this.input.keyboard.on('keyup-A', () => this.p2up('left', false));
		this.input.keyboard.on('keydown-D', () => this.p2up('right', true));
		this.input.keyboard.on('keyup-D', () => this.p2up('right', false));

		if (isDebugging()) {
			this.input.keyboard.on('keydown-P', () => {this.bombs.createOnLeftScreen()});
		}
    }

    p2up(where, flag) {
        this.cursorsWASD[where].isDown = flag?true:false;
    }

	update ()
	{
		if (this.gameOver)
        {
		    this.scene.start('GameOverScene', {gameType: 'one-vs-one', playerOne: this.playerOne, playerTwo: this.playerTwo})
            return;
        }
        if (this.playerOne.incapacitated && this.playerTwo.incapacitated)
		{
            this.gameOver = true;
            this.physics.pause();
            this.anims.pauseAll();
            multiplayerVs_SaveScore(this.playerOne, this.playerTwo)
			return;
		}

        if (this.stars && this.stars.areAllCollected()) {
            // levelup
            this.stars.newBatchOfStarsToCollect()
            this.level.up()
            this.bombs.createOnLeftScreen()
        }

		this.playerOne.update(this.cursorsWASD)
		this.playerTwo.update(this.cursorsArrowKeys)
        this.scoreText.setText(this.playerOne.count + " : " +this.playerTwo.count)
		this.levelText.setText('Level: ' + this.level.nr());
	}


}